import { render, staticRenderFns } from "./gera-pinss.vue?vue&type=template&id=59b11cb6&scoped=true"
import script from "./gera-pinss.vue?vue&type=script&lang=js"
export * from "./gera-pinss.vue?vue&type=script&lang=js"
import style0 from "./gera-pinss.vue?vue&type=style&index=0&id=59b11cb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b11cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDivider,
  VFlex,
  VImg,
  VLayout,
})
